<div class="assign-package-list-wrapper">
  <div class="message info" *ngIf="isLoading">Loading assigned package list...</div>
  <div class="message error" *ngIf="error">{{ error }}</div>

  <app-entity-list
    *ngIf="!error"
    [loading]="isLoading"
    [list]="assignments"
    [tableHeaderAndValueKeySets]="tableHeaderAndValueKeySets"
    [emptyMessage]="'No assigned packages found.'"
    [menuActions]="assignPackageMenuActions"
    (cardClick)="onCardClickFromList($event)"
    (editClick)="onEditClickFromList($event)"
    (deleteClick)="onDeleteClickFromList($event)"
    (menuAction)="onMenuAction($event)"
  ></app-entity-list>

  <div class="modal-overlay" *ngIf="isDetailsOpen && selectedAssignment" (click)="closeDetailsModal()">
    <div class="details-modal" (click)="$event.stopPropagation()">
      <button class="close-icon" type="button" aria-label="Close" (click)="closeDetailsModal()">&times;</button>
      <h3>Assign Package Details</h3>
      <div class="details-grid">
        <div class="details-item">
          <span class="label">ID</span>
          <span class="value">{{ selectedAssignment.id || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">User</span>
          <span class="value">{{ selectedAssignment.appUser?.organizationName || selectedAssignment.appUser?.name || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Mobile No</span>
          <span class="value">{{ selectedAssignment.appUser?.mobileNumber || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Email</span>
          <span class="value">{{ selectedAssignment.appUser?.email || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">User ID</span>
          <span class="value">{{ selectedAssignment.userId || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Package</span>
          <span class="value">{{ selectedAssignment.packageName || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Price</span>
          <span class="value">{{ formatPrice(selectedAssignment.price) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Total Price</span>
          <span class="value">{{ formatPrice(totalPrice(selectedAssignment.price, selectedAssignment.durationQuantity)) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Trial</span>
          <span class="value">{{ selectedAssignment.isTrial ? 'Yes' : 'No' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Status</span>
          <span class="value">{{ selectedAssignment.status === 1 ? 'Active' : 'Inactive' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Duration Unit</span>
          <span class="value">{{ durationLabel(selectedAssignment.durationUnite) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Duration Quantity</span>
          <span class="value">{{ selectedAssignment.durationQuantity || 0 }}</span>
        </div>
        <div class="details-item">
          <span class="label">Expire Date</span>
          <span class="value">{{ selectedAssignment.expireDate ? formatDate(selectedAssignment.expireDate) : 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Flat Limit</span>
          <span class="value">{{ selectedAssignment.maxActiveFlat || 0 }}</span>
        </div>
        <div class="details-item">
          <span class="label">Renter Limit</span>
          <span class="value">{{ selectedAssignment.maxActiveRenter || 0 }}</span>
        </div>
        <div class="details-item">
          <span class="label">Subuser Limit</span>
          <span class="value">{{ selectedAssignment.maxActiveEmployee || 0 }}</span>
        </div>
        <div class="details-item">
          <span class="label">File Storage</span>
          <span class="value">{{ formatStorage(selectedAssignment.maxFileStorage) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Created On</span>
          <span class="value">{{ selectedAssignment.createdOn ? formatDateTime(selectedAssignment.createdOn) : 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Created By</span>
          <span class="value">{{ actorLabel(selectedAssignment.createdByUser, selectedAssignment.createdBy) }}</span>
        </div>
        <div class="details-item" *ngIf="hasRecordedUpdate(selectedAssignment)">
          <span class="label">Updated On</span>
          <span class="value">{{ selectedAssignment.updatedOn ? formatDateTime(selectedAssignment.updatedOn) : 'N/A' }}</span>
        </div>
        <div class="details-item" *ngIf="hasRecordedUpdate(selectedAssignment) && hasUpdatedActor(selectedAssignment)">
          <span class="label">Updated By</span>
          <span class="value">{{ actorLabel(selectedAssignment.updatedByUser, selectedAssignment.updatedBy) }}</span>
        </div>
        <div class="details-item details-item-full">
          <span class="label">Remarks</span>
          <span class="value">{{ remarksLabel(selectedAssignment.remarks) }}</span>
        </div>
      </div>
      <div class="details-actions">
        <button type="button" class="panel-item" (click)="closeDetailsModal()">Close</button>
      </div>
    </div>
  </div>

  <app-add-edit-assign-package
    *ngIf="isEditOpen"
    [mode]="selectedAssignment ? 'edit' : 'create'"
    [initialAssignment]="selectedAssignment"
    (close)="closeEditModal()"
    (save)="onEditSave($event)"
  ></app-add-edit-assign-package>

  <app-confirm-action-modal
    [visible]="!!pendingDeleteAssignment"
    [title]="'assignPackage.deleteTitle' | t:'Delete Assigned Package'"
    [message]="'assignPackage.deleteMessage' | t:'Delete this package assignment?'"
    [confirmLabel]="'action.delete' | t:'Delete'"
    [isLoading]="isDeleting"
    [danger]="true"
    (cancel)="closeDeleteModal()"
    (confirm)="confirmDeleteAssignPackage()"
  ></app-confirm-action-modal>

  <div class="modal-overlay" *ngIf="isHistoryOpen && selectedAssignment" (click)="closeHistoryModal()">
    <div class="details-modal history-modal" (click)="$event.stopPropagation()">
      <button class="close-icon" type="button" aria-label="Close" (click)="closeHistoryModal()">&times;</button>
      <h3>Assign Package History</h3>
      <div class="history-subtitle">
        {{ selectedAssignment.appUser?.organizationName || selectedAssignment.appUser?.name || 'N/A' }}
      </div>

      <div class="history-list" *ngIf="selectedAssignmentHistory.length > 0; else emptyHistory">
        <div class="history-header">
          <span>Recorded On</span>
          <span>Action</span>
          <span>User</span>
          <span>Package</span>
          <span>Summary</span>
          <span>By</span>
          <span>Remarks</span>
        </div>
        <div class="history-card" *ngFor="let history of selectedAssignmentHistory" (click)="openHistoryDetails(history)">
          <span>{{ formatDateTime(history.createdOn) }}</span>
          <span>{{ history.actionStatus || 'N/A' }}</span>
          <span>{{ resolveHistoryUserName(history.userId) }}</span>
          <span class="history-package-cell">
            <span>{{ history.packageName || 'N/A' }}</span>
            <span class="history-trial-chip" *ngIf="history.isTrial">TRIAL</span>
          </span>
          <span class="history-summary">{{ historySummary(history) }}</span>
          <span>{{ historyByLabel(history) }}</span>
          <span class="history-remarks">{{ remarksLabel(history.remarks) }}</span>
        </div>
      </div>

      <ng-template #emptyHistory>
        <div class="message info">No history found.</div>
      </ng-template>

      <div class="details-actions">
        <button type="button" class="panel-item" (click)="closeHistoryModal()">Close</button>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="isHistoryDetailsOpen && selectedHistoryItem" (click)="closeHistoryDetailsModal()">
    <div class="details-modal" (click)="$event.stopPropagation()">
      <button class="close-icon" type="button" aria-label="Close" (click)="closeHistoryDetailsModal()">&times;</button>
      <h3>Assign Package History Details</h3>
      <div class="details-grid">
        <div class="details-item">
          <span class="label">History ID</span>
          <span class="value">{{ selectedHistoryItem.id || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Assign Package ID</span>
          <span class="value">{{ selectedHistoryItem.assignPackageId || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Recorded On</span>
          <span class="value">{{ formatDateTime(selectedHistoryItem.createdOn) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Created By</span>
          <span class="value">{{ actorLabel(selectedHistoryItem.createdByUser, selectedHistoryItem.createdBy) }}</span>
        </div>
        <div class="details-item" *ngIf="hasUpdatedActor(selectedHistoryItem)">
          <span class="label">Updated By</span>
          <span class="value">{{ actorLabel(selectedHistoryItem.updatedByUser, selectedHistoryItem.updatedBy) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Action</span>
          <span class="value">{{ selectedHistoryItem.actionStatus || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">User</span>
          <span class="value">{{ resolveHistoryUserName(selectedHistoryItem.userId) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Package</span>
          <span class="value">{{ selectedHistoryItem.packageName || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Price</span>
          <span class="value">{{ formatPrice(selectedHistoryItem.price) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Total Price</span>
          <span class="value">{{ formatPrice(totalPrice(selectedHistoryItem.price, selectedHistoryItem.durationQuantity)) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Trial</span>
          <span class="value">{{ selectedHistoryItem.isTrial ? 'Yes' : 'No' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Status</span>
          <span class="value">{{ selectedHistoryItem.status === 1 ? 'Active' : 'Inactive' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Duration Unit</span>
          <span class="value">{{ durationLabel(selectedHistoryItem.durationUnite) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Duration Quantity</span>
          <span class="value">{{ selectedHistoryItem.durationQuantity || 0 }}</span>
        </div>
        <div class="details-item">
          <span class="label">Expire Date</span>
          <span class="value">{{ selectedHistoryItem.expireDate ? formatDate(selectedHistoryItem.expireDate) : 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Flat Limit</span>
          <span class="value">{{ selectedHistoryItem.maxActiveFlat || 0 }}</span>
        </div>
        <div class="details-item">
          <span class="label">Renter Limit</span>
          <span class="value">{{ selectedHistoryItem.maxActiveRenter || 0 }}</span>
        </div>
        <div class="details-item">
          <span class="label">Subuser Limit</span>
          <span class="value">{{ selectedHistoryItem.maxActiveEmployee || 0 }}</span>
        </div>
        <div class="details-item">
          <span class="label">File Storage</span>
          <span class="value">{{ formatStorage(selectedHistoryItem.maxFileStorage) }}</span>
        </div>
        <div class="details-item details-item-full">
          <span class="label">Remarks</span>
          <span class="value">{{ remarksLabel(selectedHistoryItem.remarks) }}</span>
        </div>
      </div>
      <div class="details-actions">
        <button type="button" class="panel-item" (click)="closeHistoryDetailsModal()">Close</button>
      </div>
    </div>
  </div>
</div>
